import ChargeHelper from "features/Charge/chargeHelper";
import FleetHelper from "features/Fleet/fleetHelper";
import { AppCustomDialogHelper } from "general/components/AppDialogCustom";
import KTFormSearch from "general/components/OtherKeenComponents/Forms/KTFormSearch";
import KTBSDropdown, { KTBSDropdownDirections } from "general/components/OtherKeenComponents/KTBSDropdown";
import KTTable from "general/components/OtherKeenComponents/KTTable";
import tableStyle from "general/components/OtherKeenComponents/KTTable/tableStyle";
import CustomDateRangePicker, { dateFilter, getDateFilterOption } from "general/components/Others/CustomDateRangePicker";
import EmptyView from "general/components/Others/EmptyView";
import AppColors from "general/constants/AppColors";
import AppConfigs from "general/constants/AppConfigs";
import AppConstants from "general/constants/AppConstants";
import ToastHelper from "general/helpers/ToastHelper";
import UIHelper from "general/helpers/UIHelper";
import Utils from "general/utils/Utils";
import useConfigTableColumn from "hooks/useConfigTableColumn";
import useRouter from "hooks/useRouter";
import { t } from "i18next";
import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import imgEmptyNhanVien from 'assets/images/img_emptyview_user.png';
import KTPagination, { KTPaginationColor } from "general/components/OtherKeenComponents/KTPagination";
import KTLabel, { KTLabelSize } from "general/components/OtherKeenComponents/KTLabel";
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import DropdownFilterTable from "general/components/DropdownFilterTable";
import FleetTransactionFilterView from "./components/FleetTransactionFilterView";
import AppRoute from "general/constants/AppRoute";
import AgencySaleDialogView from "features/Agency/components/AgencySaleDialogView";
import DialogFleetTransactionDetailView from "./components/DialogFleetTransactionDetailView";
import * as ExcelJS from 'exceljs';

FleetTransactionView.propTypes = {
    agencyId: PropTypes.string,
    showFullUI: PropTypes.bool,
    agencyDetail: PropTypes.object,
};

const defaultColumnIds = [
    'TRANSACTION_CODE',
    'REFERENCE_CODE',
    'EXECUTOR',
    'OBJECT_TYPE',
    'TRANSACTION_TYPE',
    'AMOUNT',
    'TIME',
    'PAYMENT_METHOD',
    'DESCRIPTION',
    'STATUS'
];

function FleetTransactionView(props) {
    // MARK: ---- PARAMS ----
    const { agencyId, showFullUI = true, agencyDetail } = props;
    const router = useRouter();
    const { user } = useSelector(state => state.auth);
    const [fleetDetail, setFleetDetail] = useState();
    const [transactionList, setTransactionList] = useState([]);
    const [transactionTotal, setTransactionTotal] = useState(0);
    const [filter, setFilter] = useState({
        agencyId: agencyId,
        q: '',
        from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
        to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
        selectedValue: dateFilter.baMuoiNgayGanNhat,
        status: '',
        page: 0,
        limit: AppConfigs.defaultPageLimit,
        forRole: '',
        type: '',
    });
    const [filterDropdown, setFilterDropdown] = useState({
        agencyId: agencyId,
        q: '',
        from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
        to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
        selectedValue: dateFilter.baMuoiNgayGanNhat,
        status: '',
        page: 0,
        limit: AppConfigs.defaultPageLimit,
        forRole: '',
        type: '',
    });

    const fullColumns = useMemo(() => {
        return [
            {
                id: 'TRANSACTION_CODE',
                name: UIHelper.buildTableColumn('Mã giao dịch'),
                width: '130px',
                selector: (row) => row?.walletTransactionCode || row?.walletTransactionId,
                sortable: false,
            },
            {
                id: 'REFERENCE_CODE',
                name: UIHelper.buildTableColumn('Mã giao dịch tham chiếu/Phiên sạc'),
                width: '160px',
                selector: (row) => (
                    <KTTooltip offset={[0, 0]} text={row?.externalTransactionId}>
                        <span
                            className="cursor-pointer hover-opacity-60"
                            onClick={() => {
                                if (row?.amount < 0) {
                                    Utils.openInNewTab(`${AppRoute.chargeTransactionList}/${row?.externalTransactionId}`)
                                }
                            }}
                        >
                            {row?.externalTransactionId}
                        </span>
                    </KTTooltip>
                ),
                sortable: false,
                conditionalCellStyles: [
                    {
                        when: (row) => (row?.amount || 0) >= 0,
                        style: { color: AppColors.normal },
                    },
                    {
                        when: (row) => (row?.amount || 0) < 0,
                        style: { color: AppColors.primary },
                    },
                ],
            },
            {
                id: 'EXECUTOR',
                name: UIHelper.buildTableColumn('Người thực hiện'),
                minWidth: '180px',
                selector: (row) => (
                    <KTTooltip offset={[0, 0]} text={row?.wallet?.user?.fullname}>
                        <span
                            className="cursor-pointer hover-opacity-60"
                            onClick={() => {
                                if (row?.forRole === 'FLEET') {
                                    if (adminRole) {
                                        Utils.openInNewTab(`${AppRoute.fleetList}/${row?.wallet?.user?.agencyId}`)
                                    } else {
                                        Utils.openInNewTab(`${AppRoute.fleetInfo}/${row?.wallet?.user?.agencyId}`)
                                    }
                                } else {
                                    if (adminRole) {
                                        Utils.openInNewTab(`${AppRoute.customerList}/${row?.wallet?.userId}`)
                                    } else {
                                        Utils.openInNewTab(`${AppRoute.driverList}/${row?.wallet?.userId}`)
                                    }
                                }
                            }}
                        >
                            {row?.wallet?.user?.fullname}
                        </span>
                    </KTTooltip>
                ),
                sortable: false,
                style: tableStyle?.columns?.link,
            },
            {
                id: 'OBJECT_TYPE',
                name: UIHelper.buildTableColumn('Loại đối tượng'),
                width: '150px',
                selector: (row) => row?.forRole === 'FLEET' ? 'Doanh nghiệp VT' : 'Tài xế',
                sortable: false,
            },
            {
                id: 'TRANSACTION_TYPE',
                name: UIHelper.buildTableColumn('Loại giao dịch'),
                width: '140px',
                selector: (row) => ChargeHelper.Utils.getDriverTransactionName(row?.fundingSource),
                sortable: false,
            },
            {
                id: 'AMOUNT',
                name: UIHelper.buildTableColumn('Số tiền'),
                width: '160px',
                right: true,
                selector: (row) => {
                    const amount = row?.amount || 0;
                    return amount >= 0
                        ? `+${Utils.formatNumber(amount)}`
                        : Utils.formatNumber(amount);
                },
                sortable: false,
                conditionalCellStyles: [
                    {
                        when: (row) => (row?.amount || 0) >= 0,
                        style: { color: AppColors.primary },
                    },
                    {
                        when: (row) => (row?.amount || 0) < 0,
                        style: { color: AppColors.danger },
                    },
                ],
            },
            {
                id: 'TIME',
                name: UIHelper.buildTableColumn('Thời gian'),
                width: '160px',
                selector: (row) => Utils.formatDateTimeToString(row?.time, 'DD/MM/YYYY - hh:mm'),
                sortable: false,
            },
            {
                id: 'PAYMENT_METHOD',
                name: UIHelper.buildTableColumn('Phương thức thanh toán'),
                width: '170px',
                selector: (row) => ChargeHelper.Utils.getChargePaymentMethodName(row?.fundingSource),
                sortable: false,
            },
            {
                id: 'DESCRIPTION',
                name: UIHelper.buildTableColumn('Nội dung'),
                minWidth: '340px',
                selector: (row) => row?.description,
                sortable: false,
                wrap: true,
            },
            {
                id: 'STATUS',
                name: UIHelper.buildTableColumn('Trạng thái giao dịch'),
                width: '150px',
                sortable: false,
                cell: (row) => (
                    <KTLabel
                        text={ChargeHelper.Utils.getWalletTransactionStatusName(row?.status)}
                        isInline={true}
                        size={KTLabelSize.medium}
                        additionalClassName={`label-light-${ChargeHelper.Utils.getWalletTransactionStatusColor(
                            row?.status
                        )}`}
                    />
                ),
            },
            {
                name: UIHelper.buildTableColumn('Thao tác'),
                width: '90px',
                sortable: false,
                style: {
                    position: 'sticky',
                    right: 0,
                    backgroundColor: '#fff',
                    borderLeft: '1px solid #ebedfe',
                },
                center: true,
                cell: (row) => (
                    <div className="d-flex gap-2">
                        <KTTooltip offset={[0, 0]} text={'Xem chi tiết'}>
                            <a
                                className="btn btn-sm btn-clean btn-icon"
                                onClick={() => {
                                    handleShowTransactionDetail(row);
                                }}
                            >
                                <i
                                    className="fa-regular fa-eye"
                                    style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                />
                            </a>
                        </KTTooltip>
                    </div>
                ),
            }
        ];
    }, []);

    const prefKey = useMemo(() => {
        const userId = user.userId;
        const pathName = `${router.pathname}${router.location.hash}`;
        return `${userId}_${pathName}`;
    }, [user, router]);

    const [fullColumnIds, setFullColumnIds] = useState(fullColumns?.map((row) => row?.id).filter(Boolean));
    const {
        columnIds,
        columns,
        onChangeCheckboxValue,
        resetDefaultTableColumn,
        saveChanges,
        onSelectAll,
        onUnSelectAll,
        fullColumnsIdSorted
    } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

    const adminRole =
        user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;
    useEffect(() => {
        handleGetTransactionList();
    }, [filter, user, adminRole]);

    useEffect(() => {
        if (!agencyId) {
            setFilter(FleetHelper.Filter.transactionList);
            setFilterDropdown(FleetHelper.Filter.transactionList);
        }
    }, [])

    useEffect(() => {
        if (adminRole) {
            setFleetDetail(agencyDetail);
            return;
        }

        if (user) {
            FleetHelper.API.requestGetFleetDetail(user?.agencyId).then((data) => {
                setFleetDetail(data);
            });
        }
    }, [user, adminRole, agencyDetail]);

    const objectTypeOptions = [
        {
            name: 'Tất cả',
            value: '',
        },
        {
            name: 'Doanh nghiệp VT',
            value: 'FLEET',
        },
        {
            name: 'Tài xế',
            value: 'DRIVER',
        },
    ];

    // MARK: ---- METHODS ----

    const handleGetTransactionList = async () => {
        let params = {
            ...filter,
        }
        if (!adminRole) {
            params.agencyId = user?.agency?.agencyId;
        } else {
            params.agencyId = agencyId;
        }
        params = _.pickBy(
            params,
            (value) => value !== null && value !== undefined && value !== ''
        )
        if (params?.agencyId) {
            const res = await FleetHelper.API.requestGetFleetTransactions(params);
            const { total, transactions } = res;
            setTransactionList(transactions);
            setTransactionTotal(total);
        }
    };

    const updateFilter = (key, value) => {
        FleetHelper.Filter.transactionList = { ...FleetHelper.Filter.transactionList, [key]: value };
        setFilter(FleetHelper.Filter.transactionList);
        setFilterDropdown(FleetHelper.Filter.transactionList);
    };

    const handleShowTransactionDetail = (row) => {
        AppCustomDialogHelper.show(
            'Chi tiết giao dịch',
            <AgencySaleDialogView
                confirmButtonText={null}
                cancelButtonText="Bỏ qua"
                onCancel={() => {
                    AppCustomDialogHelper.hide();
                }}
                onlyBodyEl={true}
                bodyEl={
                    <DialogFleetTransactionDetailView
                        item={row}
                        user={user}
                        onCancel={() => {
                            AppCustomDialogHelper.hide();
                        }}
                    />
                }
            />,
            'md',
            false,
            true
        );
    }

    // xuat file excel
    const handleExportExcel = async (exportData, params) => {
        let exportDataList = exportData;
        if (_.isEmpty(exportDataList)) {
            ToastHelper.showError('Không có dữ liệu để tải xuống');
            return;
        }

        const sheetFileName = fleetDetail?.agencyCode + '_Lịch_sử_giao_dịch_' + moment(params.from).format('DDMMYYYY') + '_' + moment(params.to).format('DDMMYYYY');
        const ext = '.xlsx';
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet(sheetFileName, {
            headerFooter: { firstHeader: sheetFileName },
        });

        sheet.mergeCells('A1:K1');
        sheet.getCell('A1').value = `LỊCH SỬ GIAO DỊCH DNVT ${fleetDetail?.name?.toUpperCase()} (NGÀY ${moment(params.from).format(
            'DD/MM/YYYY'
        )} - ${moment(params.to).format('DD/MM/YYYY')})`;
        sheet.getCell('A1').font = {
            name: 'Times New Roman',
            family: 4,
            size: 11,
            bold: true,
            color: { argb: 'FFFFFFFF' },
        };
        sheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        sheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '29618E' },
            color: { argb: 'FFFFFF' },
        };
        sheet.getCell('A1').border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };
        sheet.getRow(1).height = 25;

        const columns = [
            { key: 'stt', width: 7 },
            { key: 'transactionCode', width: 18 },
            { key: 'referenceCode', width: 18 },
            { key: 'executor', width: 30 },
            { key: 'objectType', width: 18 },
            { key: 'transactionType', width: 18 },
            { key: 'amount', width: 22 },
            { key: 'time', width: 18 },
            { key: 'paymentMethod', width: 22 },
            { key: 'description', width: 60 },
            { key: 'status', width: 20 },
        ];
        sheet.columns = columns;

        sheet.getRow(2).height = 30;
        sheet.getRow(2).font = {
            name: 'Times New Roman',
            family: 4,
            size: 11,
            bold: true,
        };
        sheet.getRow(2).alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
        };

        sheet.getCell('A2').value = 'STT';
        sheet.getCell('B2').value = 'Mã giao dịch';
        sheet.getCell('C2').value = 'Mã giao dịch tham chiếu/Phiên sạc';
        sheet.getCell('D2').value = 'Người thực hiện';
        sheet.getCell('E2').value = 'Loại đối tượng';
        sheet.getCell('F2').value = 'Loại giao dịch';
        sheet.getCell('G2').value = 'Số tiền';
        sheet.getCell('H2').value = 'Thời gian';
        sheet.getCell('I2').value = 'Phương thức thanh toán';
        sheet.getCell('J2').value = 'Nội dung';
        sheet.getCell('K2').value = 'Trạng thái giao dịch';


        ['A2:K2'].forEach((range) => {
            sheet.getRow(range.split(':')[0].slice(1)).eachCell({ includeEmpty: true }, (cell) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
            });
        });

        let i = 1;
        exportDataList?.forEach((row) => {
            const dataRow = sheet.addRow({
                stt: i++,
                transactionCode: row?.walletTransactionCode || row?.walletTransactionId,
                referenceCode: row?.externalTransactionId,
                executor: row?.wallet?.user?.fullname,
                objectType: row?.forRole === 'FLEET' ? 'Doanh nghiệp VT' : 'Tài xế',
                transactionType: ChargeHelper.Utils.getDriverTransactionName(row?.fundingSource),
                amount: row?.amount >= 0
                    ? `+${Utils.formatNumber(row?.amount)}`
                    : Utils.formatNumber(row?.amount),
                time: Utils.formatDateTimeToString(row?.time, 'DD/MM/YYYY - hh:mm'),
                paymentMethod: ChargeHelper.Utils.getChargePaymentMethodName(row?.fundingSource),
                description: row?.description,
                status: ChargeHelper.Utils.getWalletTransactionStatusName(row?.status),
            });

            dataRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
                if (colNumber === 1) {
                    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                } else if (colNumber == 7) {
                    cell.alignment = { vertical: 'middle', horizontal: 'right', wrapText: true };
                } else {
                    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
                }
            });
        });

        sheet.eachRow((row, rowNumber) => {
            if (rowNumber >= 3) {
                row.font = {
                    name: 'Times New Roman',
                    family: 4,
                    size: 11,
                    bold: false,
                };
            }
        });

        workbook.xlsx.writeBuffer().then(function (data) {
            const blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = sheetFileName + ext;
            anchor.click();
            window.URL.revokeObjectURL(url);
            ToastHelper.showSuccess('Tải xuống file Excel thành công');
            AppCustomDialogHelper.hide();
        });
    };

    return (
        <div className={showFullUI ? "px-4 my-4" : ''}>
            {UIHelper.buildCard(
                <div>
                    <div className={`px-4 pb-4 ${showFullUI ? 'pt-4' : ''}`}>
                        {/* header */}
                        {showFullUI && (
                            <div className="d-flex justify-content-between align-items-center">
                                {/* title */}
                                <div className="d-flex flex-column align-items-start">
                                    <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                                        Lịch sử giao dịch
                                    </span>
                                    <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                        Tổng số:{' '}
                                        <span style={{ color: AppColors.primary }}>
                                            {Utils.formatNumber(transactionTotal)} giao dịch
                                        </span>
                                    </span>
                                </div>
                                <div>
                                    {UIHelper.buildBlueButton(
                                        'Tải xuống',
                                        async () => {
                                            try {
                                                ChargeHelper.UI.Excel.showDialogDownloadExcelFile(
                                                    filter,
                                                    async (params) => {
                                                        try {
                                                            const { transactions = [] } = await FleetHelper.API.requestGetFleetTransactions(params);
                                                            return handleExportExcel(transactions, params);
                                                        } catch (error) {
                                                            ToastHelper.showError(`Lỗi khi lấy dữ liệu: ${error.message}`);
                                                            return [];
                                                        }
                                                    },
                                                );
                                            } catch (error) {
                                                ToastHelper.showError(`Lỗi khi khởi tạo tải xuống: ${error.message}`);
                                            }
                                        },
                                        <i className="fa-regular fa-download" style={{ fontSize: 15 }} />
                                    )}
                                </div>
                            </div>
                        )}

                        <div className="w-100 d-flex m-0 pt-4 pb-2 align-items-end">
                            {/* tim kiem */}
                            <div className="w-25 pl-0 pr-2">
                                <label htmlFor="search-bar" className="mb-0 mr-2 font-weight-bolder">
                                    {t('search')}
                                </label>
                                <KTFormSearch
                                    name="search-bar"
                                    placeholder="Theo mã giao dịch, mã tham chiếu, phiên sạc, người thực hiện"
                                    value={filter.q}
                                    onSubmit={(text) => {
                                        updateFilter('q', text);
                                        updateFilter('page', 0);
                                    }}
                                />
                            </div>

                            {/* loc theo loai doi tuong*/}
                            <div className="w-25 px-2">
                                <label htmlFor="status" className="mb-0 mr-2 font-weight-bolder">
                                    Loại đối tượng
                                </label>
                                <KTBSDropdown
                                    toggleElement={
                                        <button
                                            className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                            type="button"
                                        >
                                            {objectTypeOptions.find((item) => item.value === filter.forRole)
                                                ?.name ?? "Tất cả"}
                                        </button>
                                    }
                                    selectedValue={filter.forRole}
                                    dropdownMenuItems={objectTypeOptions}
                                    dropdownMenuClassName="overflow-auto w-100"
                                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                                    onChange={(value) => {
                                        updateFilter('forRole', value);
                                        updateFilter('page', 0);
                                    }}
                                    isDropdownForm={true}
                                    direction={showFullUI ? KTBSDropdownDirections.down : KTBSDropdownDirections.up}
                                />
                            </div>

                            {/* loc theo loai giao dich*/}
                            <div className="w-25 px-2">
                                <label htmlFor="status" className="mb-0 mr-2 font-weight-bolder">
                                    Trạng thái
                                </label>
                                <KTBSDropdown
                                    toggleElement={
                                        <button
                                            className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                            type="button"
                                        >
                                            {ChargeHelper.Data.walletTransactionStatusOptions.find((item) => item.value === filter.status)
                                                ?.name ?? "Tất cả"}
                                        </button>
                                    }
                                    selectedValue={filter.status}
                                    dropdownMenuItems={[
                                        { name: 'Tất cả', value: '' },
                                        ...ChargeHelper.Data.walletTransactionStatusOptions
                                    ]}
                                    dropdownMenuClassName="overflow-auto w-100"
                                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                                    onChange={(value) => {
                                        updateFilter('status', value);
                                        updateFilter('page', 0);
                                    }}
                                    isDropdownForm={true}
                                    direction={showFullUI ? KTBSDropdownDirections.down : KTBSDropdownDirections.up}
                                />
                            </div>

                            {/* loc theo khoang thoi gian */}
                            <div className="w-25 px-2">
                                {UIHelper.buildFormLabel('Khoảng thời gian')}
                                <CustomDateRangePicker
                                    alignRight={true}
                                    toggleFontWeight="400"
                                    toggleElementBorderRadius={5}
                                    initialValue={filter.selectedValue}
                                    onPressSave={(selectedValue, startDate, endDate) => {
                                        updateFilter('selectedValue', selectedValue);
                                        updateFilter('from', startDate);
                                        updateFilter('to', endDate);
                                        updateFilter('page', 0);
                                    }}
                                    direction={showFullUI ? KTBSDropdownDirections.down : KTBSDropdownDirections.up}
                                />
                            </div>

                            {/* bo loc */}
                            {!adminRole && (
                                <div className="pl-2" style={{ minWidth: 100 }}>
                                    <DropdownFilterTable
                                        filterComponent={[
                                            <div>
                                                <FleetTransactionFilterView
                                                    setFilterDropdown={setFilterDropdown}
                                                    filterDropdown={filterDropdown}
                                                />
                                            </div>
                                        ]}
                                        resetDefaultTable={() => {
                                            const updateFilterDropdown = {
                                                ...filterDropdown,
                                                q: '',
                                                from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                                                to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                                                selectedValue: dateFilter.baMuoiNgayGanNhat,
                                                status: '',
                                                page: 0,
                                                limit: AppConfigs.defaultPageLimit,
                                                forRole: '',
                                                type: '',
                                            };
                                            setFilterDropdown(updateFilterDropdown);
                                            setFilter(updateFilterDropdown);
                                            FleetHelper.Filter.transactionList = updateFilterDropdown;
                                        }}
                                        saveFilter={() => {
                                            setFilter(filterDropdown);
                                            FleetHelper.Filter.transactionList = filterDropdown;
                                        }}
                                        isDefaultFilter={Utils.checkDefaultFilter(
                                            ['agencyId', 'page', 'limit', 'from', 'to', 'selectedValue'],
                                            filter,
                                            dateFilter.baMuoiNgayGanNhat
                                        )}
                                    />
                                </div>
                            )}

                            {!showFullUI && (
                                <div className="pl-2">
                                    {UIHelper.buildBlueButton(
                                        'Tải xuống',
                                        async () => {
                                            try {
                                                ChargeHelper.UI.Excel.showDialogDownloadExcelFile(
                                                    filter,
                                                    async (params) => {
                                                        try {
                                                            const { transactions = [] } = await FleetHelper.API.requestGetFleetTransactions(params);
                                                            return handleExportExcel(transactions, params);
                                                        } catch (error) {
                                                            ToastHelper.showError(`Lỗi khi lấy dữ liệu: ${error.message}`);
                                                            return [];
                                                        }
                                                    },
                                                );
                                            } catch (error) {
                                                ToastHelper.showError(`Lỗi khi khởi tạo tải xuống: ${error.message}`);
                                            }
                                        },
                                        <i className="fa-regular fa-download" />
                                    )}
                                </div>
                            )}
                        </div>

                        {/* body */}
                        <div className="mt-4">
                            <KTTable
                                columns={columns}
                                items={transactionList}
                                selectableRows={false}
                                striped={false}
                                compactGrid={false}
                                onClickedRow={() => { }}
                                onSelectedRowsChanged={(rows) => { }}
                                onDoubleClickedRow={(rows) => { }}
                                hasActionColumn={true}
                                noDataComponent={
                                    <EmptyView
                                        icon={imgEmptyNhanVien}
                                        title="Không có dữ liệu để hiển thị"
                                        text={
                                            <div className="text-center">
                                                <span>
                                                    Hiện không có dữ liệu để hiển thị. Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.
                                                </span>
                                            </div>
                                        }
                                    />
                                }
                            />
                        </div>

                        {/* phan trang */}
                        {!_.isEmpty(transactionList) && (
                            <div className="mt-4">
                                <KTPagination
                                    currentPage={filter.page + 1}
                                    rowCount={transactionTotal}
                                    rowsPerPage={filter.limit}
                                    currentItemInPageCount={transactionList.length}
                                    onChangePage={(newPage) => {
                                        const iNewPage = parseInt(newPage);
                                        updateFilter('page', iNewPage - 1);
                                    }}
                                    onChangeRowsPerPage={(newRowsPerPage) => {
                                        const iNewRowsPerPage = parseInt(newRowsPerPage);
                                        updateFilter('limit', iNewRowsPerPage);
                                        updateFilter('page', 0);
                                    }}
                                    loading={false}
                                    color={KTPaginationColor.success}
                                    appendText="giao dịch"
                                />
                            </div>
                        )}

                    </div>
                </div>,
                false,
                false,
                true,
                false,
                AppColors.gray[300],
                adminRole
            )}
        </div>
    );
}

export default FleetTransactionView;